<template>
  <div>
    <a-card>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                :beforeSend="master.beforeSend"
                ref="master"
                :useMultipart="true"
                @action="masterAction"
                :actions="master.actions"
                modalWidth="80%"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Origen')"
                          :formItemConfig="fiOptions"
                          endpoint="hierarchy_lookup"
                          :decorator="['id_h_origin', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                          :params="id_h_origin"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Rango de incapacidades')"
                          :formItemConfig="fiOptions"
                          endpoint="hierarchy_lookup"
                          :decorator="['id_h_disabilities_range', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                          :params="id_h_disabilities_range"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('C. de rehabilitación')"
                          :formItemConfig="fiOptions"
                          endpoint="hierarchy_lookup"
                          :decorator="['id_h_coc_rehabilitation', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                          :params="id_h_coc_rehabilitation"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['inability', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  Incapacidad
                </a-checkbox>
                <a-checkbox
                  v-decorator="['reincorporate', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  Reincorporación
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Observaciones generales')">
                <a-textarea style="width: 100%"
                            v-decorator="['observations', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Concepto rehabilitación')">
                <a-upload
                  :before-upload="beforeUploadCr"
                  :fileList="master.uploads.cr"
                  :remove="() => { master.uploads.cr = [] }">
                  <a-button style="width: 100%">Seleccionar archivo</a-button>
                </a-upload>
              </a-form-item>
            </a-col>
            <a-divider orientation="left">
              PCL
            </a-divider>
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Entidad')"
                          :formItemConfig="fiOptions"
                          endpoint="hierarchy_lookup"
                          :decorator="['id_h_pcl_entity', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                          :params="id_h_pcl_entity"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Fecha')">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['pcl_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                ></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Dictamen (%PCL)')" v-bind="fiOptions">
                <a-input-number style="width: 100%"
                                v-decorator="['pcl_percentage', { rules: [{ required: false}] }]"
                ></a-input-number>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('PCL')">
                <a-upload
                  :before-upload="beforeUpload"
                  :fileList="master.uploads.profileFile"
                  :remove="() => { master.uploads.profileFile = [] }">
                  <a-button style="width: 100%">Seleccionar archivo</a-button>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-card>
  </div>
</template>
<script>
  import Mensajes from '../../Util/Mensajes'
  import HttpUtil from '../../../../util/HttpUtil'
  export default {
    data () {
      return {
        loadingBtns: {},
        loadingBtnsCr: {},
        id_h_origin: {
          h_lookup_type: 'INCAPACIDADES_ORIGEN'
        },
        id_h_disabilities_range: {
          h_lookup_type: 'INCAPACIDADES_RANGO_INCAPACIDADES'
        },
        id_h_coc_rehabilitation: {
          h_lookup_type: 'INCAPACIDADES_CONCEPTO_REHABILITACION'
        },
        id_h_pcl_entity: {
          h_lookup_type: 'INCAPACIDADES_ENTIDAD_PCL_SST'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          uploads: {
            profileFile: [],
            cr: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.file_pcl = this.master.uploads.profileFile[0]
            }
            if (this.master.uploads.cr.length > 0) {
              data.file_cr = this.master.uploads.cr[0]
            }
            return data
          },
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: (record) => {
                return this.$userIsInrol('SST-Director') || this.$userIsInrol('SST-Auxiliar')
              }
            }],
          endpoint: 'absen_sst',
          tableSetup: {
            actions: {
              width: 150,
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return this.$userIsInrol('SST-Auxiliar')
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return this.$userIsInrol('SST-Director')
                  }
                },
                {
                  name: 'downloadPcl',
                  text: 'Descargar PCL',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'file-pdf', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name_pcl
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                },
                {
                  name: 'downloadCr',
                  text: 'Descargar concepto rehabilitación',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'file-pdf', style: 'color: purple'},
                  fnVisible: (record) => {
                    return record.file_name_rehabilitation
                  },
                  fnLoading: (record) => {
                    return this.loadingBtnsCr[record.id] === record.id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Origen', dataIndex: 'origen', sorter: true},
              {title: 'Rango de incapacidades', dataIndex: 'rango', sorter: true},
              {title: 'Rehabilitación', dataIndex: 'rehabilitacion', sorter: true},
              {title: 'Entidad', dataIndex: 'entidad', sorter: true},
              {title: 'Fecha', dataIndex: 'fecha', sorter: true},
              {title: 'Dictamen (%)', dataIndex: 'pcl_percentage', sorter: true},
              {title: 'Incapacidad', dataIndex: 'inhabilitacion', sorter: true},
              {title: 'Reincorporación', dataIndex: 'reincorporacion', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'Observaciones generales', dataIndex: 'observations', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    props: ['abs_id'],
    computed: {
      parentData () {
        return {
          abs_id: this.abs_id
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
          this.master.uploads.cr = []
        }
        switch (action.action) {
          case 'downloadPcl':
            this.downloadFile(action.record, 'pcl')
            break
          case 'downloadCr':
            this.downloadFile(action.record, 'cr')
            break
        }
      },
      downloadFile (record, type) {
        if (type === 'pcl') {
          this.loadingBtns[record.id] = record.id
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        } else {
          this.loadingBtnsCr[record.id] = record.id
          this.loadingBtnsCr = Object.assign({}, this.loadingBtnsCr)
        }
        this.httpClient.getInstance().post('absen_sst/download', {
          id: record.id,
          type: type
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          if (type === 'pcl') {
            delete this.loadingBtns[record.id]
            this.loadingBtns = Object.assign({}, this.loadingBtns)
          } else {
            delete this.loadingBtnsCr[record.id]
            this.loadingBtnsCr = Object.assign({}, this.loadingBtnsCr)
          }
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      beforeUploadCr (file) {
        if (this.validateFile(file)) {
          this.master.uploads.cr = [file]
        }
        return false
      },
      validateFile (file) {
        /*const typeMime = ['gif', 'png', 'jpeg', 'jpg', 'pdf', 'plain', 'html']
        let ext = file.type.split('/')[1]
        if (!typeMime.includes(ext)) {
          this.$message.error('Solo se pemiten archivos de extensión ' + typeMime.toString())
          return false
        }*/
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/AbsenSst.vue